import { useMemo } from 'react';

import useUserRole from '../../../hooks/useUserRole';

export default function useCols() {
  const { isSuperAdmin } = useUserRole();

  const cols = useMemo(() => {
    const defaultCols = [
      {
        title: 'Number',
        key: 'number',
        link: (row) => `/loan-files/${row.id}/details`,
      },
      {
        title: 'Borrower',
        key: 'borrowers',
        format: (value) => {
          if (!value) {
            return '';
          }

          const borrower = value.find((borrower) => !borrower.isCoborrower);

          if (borrower) {
            return `${borrower.firstName} ${borrower.lastName}`;
          }
        },
      },
      {
        title: 'Coborrower',
        key: 'coborrower',
        format: (value, row) => {
          const borrowers = row.borrowers;

          if (!borrowers) {
            return '';
          }

          const coborrowers = borrowers.filter(
            (borrower) => borrower.isCoborrower
          );

          if (coborrowers.length) {
            return coborrowers
              .map((borrower) => `${borrower.firstName} ${borrower.lastName}`)
              .join(', ');
          }
        },
      },
      {
        title: 'Date submitted',
        key: 'createdAt',
        type: 'date',
      },
      {
        title: 'Status',
        key: 'status',
        type: 'badge',
        color: (status) => {
          switch (status) {
            case 'Pending':
              return 'orange';
            case 'Incomplete':
              return 'orange';
            case 'Underwriting':
              return 'yellow';
            case 'Pre-approved':
              return 'green';
            case 'Approved':
              return 'green';
            case 'Clear to Close':
              return 'green';
            case 'Clear to Close - Funding':
              return 'green';
            case 'Originated':
              return 'primary';
            case 'Approved - Not Accepted':
              return 'green';
            case 'Denied - Pre-Approval':
              return 'red';
            case 'Withdrawn':
              return 'gray';
            case 'Denied':
              return 'red';
            case 'Closed for Incompleteness':
              return 'gray';
            case 'Archived':
              return 'gray';
            default:
              return 'primary';
          }
        },
      },
    ];

    if (isSuperAdmin) {
      return [
        defaultCols[0],
        {
          title: 'Broker',
          key: 'broker.name',
        },
        ...defaultCols.slice(1),
      ];
    } else {
      return defaultCols;
    }
  }, [isSuperAdmin]);

  return cols;
}
